<template>
    <div class="overflow-y-auto h-screen-header">
        <div class="d-flex justify-content-between align-items-center mb-3">
            <div class="tabs tabs-boxed mb-2 bg-base-100 !flex">
                <div class="flex justify-between w-full">
                    <div>
                        <a v-for="{ value, text } in options" :key="value"
                            :class="{ 'tab': true, 'tab-active': sortValue === value }">
                            <router-link :to="{ 'path': '/playlists/' + value }">
                                {{ text }}
                            </router-link>
                        </a>
                    </div>
                    <div>
                        <button class="btn btn-sm mr-1" @click="handleImportPlayList">导入歌单</button>
                        <button class="btn btn-sm" @click="handleAiPlayList">智能歌单</button>
                        <dialog id="ai-list" ref="ai-list" class="modal">
                            <div class="modal-box md:overflow-y-visible w-2/3 max-w-5xl">
                                <h3 class="text-lg font-bold">创建智能播放列表</h3>
                                <div class="py-4 z-20">
                                    <div class="mb-2">
                                        <span>列表名称：</span>
                                        <input type="text" placeholder="请输入播放列表名称"
                                            class="input input-bordered input-sm w-full max-w-xs"
                                            v-model="playlistName" />
                                    </div>
                                    <div v-for="(item, index) in conditions" :key="'a' + index">
                                        <div class="flex items-center">
                                            <div v-if="index === 0">满足条件</div>
                                            <div v-else>
                                                <div class="btn btn-sm">或</div>
                                                满足条件
                                            </div>
                                            <div class="ml-2 flex">
                                                <button class="btn btn-square btn-outline btn-sm mr-1"
                                                    @click="addItem">+</button>
                                                <button class="btn btn-square btn-outline btn-sm"
                                                    @click="removeItem(index)" v-if="conditions.length > 1">-</button>
                                            </div>
                                        </div>
                                        <div class="flex mt-2 ml-6 items-center" v-for="(sub, subIndex) in item"
                                            :key="'s' + index + 'a' + subIndex">
                                            <div v-if="subIndex >= 1" class="mr-1 btn btn-sm">且</div>
                                            <single-select
                                                v-model="sub.key"
                                                :options="keyOptions"
                                                class="mr-1"
                                            />
                                            <single-select
                                                v-if="boolKeyList.indexOf(sub.key) !== -1"
                                                v-model="sub.operate"
                                                :options="operateOptions"
                                                class="mr-1"
                                            />
                                            <single-select
                                                v-else-if="numberKeyList.indexOf(sub.key) !== -1"
                                                v-model="sub.operate"
                                                :options="operateGteOptions"
                                                class="mr-1"
                                            />
                                            <single-select
                                                v-else
                                                v-model="sub.operate"
                                                :options="valueOptions"
                                                class="mr-1"
                                            />
                                            <select class="select select-bordered select-sm w-full max-w-xs"
                                                v-if="boolKeyList.indexOf(sub.key) !== -1" v-model="sub.value">
                                                <option value="">True</option>
                                            </select>
                                            <div class="w-full max-w-xs flex items-center"
                                                v-else-if="numberKeyList.indexOf(sub.key) !== -1">
                                                <input type="number" placeholder="请输入"
                                                    class="input input-bordered input-sm w-full max-w-xs"
                                                    v-model="sub.value" />
                                                <div class="ml-2" v-if="sub.key === 'bit-rate'">kps</div>
                                                <div class="ml-2" v-else-if="sub.key === 'size'">MB</div>
                                                <div class="ml-2" v-else-if="sub.key === 'play-count'">次</div>
                                                <div class="ml-2" v-else-if="sub.key === 'year'">年</div>
                                                <div class="ml-2" v-else-if="sub.key === 'duration'">秒</div>
                                                <div class="ml-2" v-else-if="sub.key === 'accessed-date'">天</div>
                                                <div class="ml-2" v-else-if="sub.key === 'created-at'">天</div>
                                                <div v-else></div>
                                            </div>
                                            <div class="w-full max-w-xs" v-else>
                                                <input type="text" placeholder="请输入"
                                                    class="input input-bordered input-sm w-full max-w-xs"
                                                    v-model="sub.value" />
                                            </div>
                                            <div class="ml-2 flex">
                                                <button class="btn btn-square btn-outline btn-sm mr-1"
                                                    @click="addSubItem(index)">+</button>
                                                <button class="btn btn-square btn-outline btn-sm"
                                                    @click="removeSubItem(index, subIndex)"
                                                    v-if="item.length > 1">-</button>
                                            </div>
                                        </div>
                                        <div class="divider"
                                            v-if="conditions.length > 1 && conditions.length !== index + 1">OR</div>
                                    </div>
                                    <div class="flex mt-4 items-center">
                                        <div class="w-8 mr-1">最多</div>
                                        <input type="text" placeholder="请输入"
                                            class="input input-bordered input-sm w-16 max-w-xs mr-1" v-model="limit" />
                                        <select class="select select-bordered select-sm w-16 max-w-xs mr-2"
                                            v-model="unit">
                                            <option value="item">项</option>
                                        </select>
                                        <div class="w-16 mr-1">选择标准</div>
                                        <single-select
                                            v-model="selectStandard"
                                            :options="selectStandardOptions"
                                        />
                                    </div>
                                    <div class="form-control w-24">
                                        <label class="cursor-pointer label">
                                            <input type="checkbox" class="checkbox checkbox-secondary"
                                                v-model="isDynamic" />
                                            <span class="label-text">动态更新</span>
                                        </label>
                                    </div>
                                </div>
                                <div class="modal-action">
                                    <form method="dialog">
                                        <button class="btn btn-neutral btn-sm mr-2" @click="handleCreate">确认</button>
                                        <button class="btn btn-sm">取消</button>
                                    </form>
                                </div>
                            </div>
                        </dialog>
                        <dialog ref="import-list" class="modal">
                            <div class="modal-box">
                                <form method="dialog">
                                    <button class="btn btn-sm btn-circle btn-ghost absolute right-2 top-2">✕</button>
                                </form>
                                <h3 class="font-bold text-lg mb-4">导入播放列表</h3>
                                <div class="text-gray-400 mb-2">
                                    导入一个播放列表，支持 m3u8 文件。
                                </div>
                                <!-- <div class="mb-2">
                                    <span>列表名称：</span>
                                    <input type="text" placeholder="请输入播放列表名称" class="input input-bordered input-sm w-full max-w-xs" v-model="playlistName" />
                                </div> -->
                                <!-- <div role="tablist" class="tabs tabs-boxed w-80 mb-2"> -->
                                <!-- <a role="tab" class="tab tab-active">文件导入</a> -->
                                <!-- <a role="tab" class="tab">网易云歌单</a> -->
                                <!-- <a role="tab" class="tab">QQ音乐歌单</a> -->
                                <!-- </div> -->
                                <input type="file" class="file-input file-input-bordered file-input-sm w-full max-w-xs"
                                    @change="onFileChange" />
                                <div class="modal-action">
                                    <button class="btn btn-sm btn-neutral" @click="uploadFile">保存</button>
                                    <form method="dialog">
                                        <!-- if there is a button in form, it will close the modal -->
                                        <button class="btn btn-sm">取消</button>
                                    </form>
                                </div>
                            </div>
                        </dialog>
                    </div>
                </div>

            </div>
        </div>
        <Tiles v-if="playlist.length > 0">
            <Tile v-for="item in playlist" :key="item.id" :image="item.image"
                :to="{ name: 'playlist', params: { id: item.id } }" :title="item.name" :square="false" :small="false"
                :allow-h-scroll="false">
                <template #text>
                    <router-link :to="{ name: 'playlist', params: { id: item.id } }">
                        <strong>{{ item.trackCount }}</strong> 歌曲
                    </router-link>
                </template>
                <template #play>
                    <div class="absolute top-[43%] z-10 left-[39%] play-icon cursor-pointer" @click="playNow(item.id)">
                        <svg class="fill-purple-800 w-12 h-12 hover:fill-purple-600" viewBox="0 0 1024 1024"
                            version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2415" width="32" height="32">
                            <path
                                d="M512 1024A512 512 0 1 1 512 0a512 512 0 0 1 0 1024zM383.232 287.616v448l384-223.104-384-224.896z"
                                p-id="2416"></path>
                        </svg>
                    </div>
                </template>
            </Tile>
        </Tiles>
    </div>
</template>
<script>
import Tiles from '@/components/library/Tiles'
import Tile from '@/components/library/Tile'
import SingleSelect from '@/components/iview/SingleSelect'
export default {
    name: 'playlists',
    components: {
        Tiles, Tile, SingleSelect
    },
    props: {
    },
    data() {
        return {
            options: [
                { text: '最近添加', value: 'recently-added' },
                { text: 'A-Z排序', value: 'a-z' }
            ],
            playlist: [],
            playlistName: '',
            limit: 25,
            unit: 'item',
            selectStandard: '?',
            isDynamic: false,
            showAddModal: false,
            conditions: [[
                { 'key': 'favourite-track', 'operate': 'is', 'value': '' }
            ]],
            boolKeyList: ['favourite-track', 'favourite-album', 'favourite-artist', 'album-img', 'artist-img'],
            numberKeyList: ['play-count', 'sample-rate', 'bit-rate', 'size', 'year', 'duration', 'accessed-date',
                'created-at'],
            selectedFile: null,
            keyOptions: [
                { id: 'favourite-track', name: '标记为喜爱的歌曲' },
                { id: 'favourite-album', name: '标记为喜爱的专辑' },
                { id: 'favourite-artist', name: '标记为喜爱的艺术家' },
                { id: 'file-path', name: '文件路径' },
                { id: 'title', name: '标题' },
                { id: 'album', name: '专辑' },
                { id: 'artist', name: '艺术家' },
                { id: 'genre', name: '流派' },
                { id: 'comment', name: '描述' },
                { id: 'lyrics', name: '歌词' },
                { id: 'language', name: '语言' },
                { id: 'label', name: '标签' },
                { id: 'play-count', name: '播放次数' },
                { id: 'bit-rate', name: '比特率' },
                { id: 'size', name: '大小' },
                { id: 'year', name: '年份' },
                { id: 'duration', name: '时长' },
                { id: 'accessed-date', name: '距离最近播放' },
                { id: 'created-at', name: '距离最近添加' },
                { id: 'album-img', name: '专辑图片' },
                { id: 'artist-img', name: '艺术家图片' },
            ],
            operateOptions: [
                { id: 'is', name: '是' },
                { id: 'not', name: '不是' },
            ],
            operateGteOptions: [
                { id: 'gte', name: '大于' },
                { id: 'lte', name: '小于' },
                { id: 'is', name: '是' },
                { id: 'not', name: '不是' },
            ],
            valueOptions: [
                { id: 'contain', name: '包含' },
                { id: 'not_contain', name: '不包含' },
                { id: 'startwith', name: '开头是' },
                { id: 'endwith', name: '结尾是' },
                { id: 'is', name: '是' },
                { id: 'not', name: '不是' },
            ],
            selectStandardOptions: [
                { id: '?', name: '随机' },
                { id: '-accessed_date', name: '最近播放' },
                { id: 'accessed_date', name: '最早播放' },
                { id: '-plays_count', name: '最常播放' },
                { id: 'plays_count', name: '最少播放' },
                { id: '-created_at', name: '最近添加' },
                { id: 'created_at', name: '最早添加' },
            ]
        }
    },
    computed: {
        sortValue: {
            get() {
                return this.$route.params.sort
            }
        }
    },
    watch: {
        // sortValue: {
        //     async handler() {
        //         this.playlist = await this.$api.subsonic.getPlaylists(this.sortValue)
        //     }
        // }
    },
    async created() {
        this.playlist = await this.$api.subsonic.getPlaylists(this.sortValue)
    },
    methods: {
        async playNow(id) {
            const playlist = await this.$api.subsonic.getPlaylist(id)
            return this.$store.dispatch('playTrackList', {
                tracks: playlist.tracks
            })
        },
        handleAiPlayList() {
            this.$refs["ai-list"].showModal()
        },
        handleImportPlayList() {
            this.$refs["import-list"].showModal()
        },
        addSubItem(index) {
            this.conditions[index].push({ 'key': '', 'operate': '', 'value': '' })
        },
        removeSubItem(index, subIndex) {
            if (this.conditions[index].length > 1) {
                this.conditions[index].splice(subIndex, 1)
            }
        },
        addItem() {
            this.conditions.push([{ 'key': '', 'operate': '', 'value': '' }])
        },
        removeItem(index) {
            this.conditions.splice(index, 1)
        },
        handleCreate() {
            if (!this.playlistName) {
                this.$myMsg.notify({
                    title: '警告！',
                    content: '播放列表名称不能为空！',
                    type: 'warning',
                    time: 2000,
                })
                return
            }
            this.$api.subsonic.createPlaylistAi(this.playlistName,
                JSON.stringify(this.conditions), this.limit, this.selectStandard, this.isDynamic).then((res) => {
                    this.$myMsg.notify({
                        title: '添加成功！',
                        type: 'success',
                        time: 2000,
                    })
                    this.$refs["ai-list"].close()
                    this.$api.subsonic.getPlaylists(this.sortValue).then((res) => {
                        this.playlist = res
                    })

                })
        },
        onFileChange(event) {
            this.selectedFile = event.target.files[0];
        },
        uploadFile() {
            const formData = new FormData()
            formData.append('file', this.selectedFile)
            this.$api.Task.importPlaylist(formData).then((res) => {
                if (res.result) {
                    this.$myMsg.notify({
                        title: '导入成功！',
                        type: 'success',
                        time: 2000,
                    })
                    this.$refs["import-list"].close()
                    this.$api.subsonic.getPlaylists(this.sortValue).then((res) => {
                        this.playlist = res
                    })
                } else {
                    this.$myMsg.notify({
                        title: '导入失败！',
                        content: res.message,
                        type: 'error',
                        time: 2000,
                    })
                }
            })
        }
    }
}
</script>
